
  








export const featuredPortfolio = [
  {
    id: 1,
    title: "Weather App",
    link:"https://weathercheck-h62r.onrender.com/",
    img:
      "./assets/img/w1.jpg",
      // video: "./assets/weather.mp4" 
  },
  {
    id: 2,
    title: "Placement Management system",
    link:"https://placement-management-system45.onrender.com/",
    img:
      "./assets/img/p2.png",
  },
  {
    id: 3,
    title: "Music",
    link:"https://45music.netlify.app",
    img:
      "./assets/img/m2.png",
  },
  {
    id: 4,
    title: "speech to text",
    link:"https://speechtotextrecog.netlify.app",
          img: "./assets/img/s1.png",
  },
  {
    id: 5,
    title: "survey",
    link:"surveyreact.netlify.app",
    img: "./assets/5.jpg",
  },
  {
    id: 6,
    title: "portfolio",
    link:"https://portfoliobhushan.netlify.app",
    img: "./assets/6.jpg",
  },
];

export const webPortfolio = [
  {
    id: 1,
    title: "Music",
    link:"https://45music.netlify.app",
    img:
      "./assets/3.jpg",
  },
  {
    id: 2,
    title: "portfolio",
    link:"https://portfoliobhushan.netlify.app",
    img: "./assets/6.jpg",
  },

 
];

export const mobilePortfolio = [
  {
    id: 1,
    title: "survey",
    link:"surveyreact.netlify.app",
    img: "./assets/5.jpg",
  },
  {id: 2,
    title: "speech to text",
    link:"https://speechtotextrecog.netlify.app",
          img: "./assets/4.jpg",

  }
 
];

export const designPortfolio = [
  {
    id: 1,
    title: "Weather App",
    link:"https://weathercheck-h62r.onrender.com/",
    img:
      "./assets/1.jpg",
  },
  {
    id: 2,
    title: "Placement Management system",
    link:"https://placement-management-system45.onrender.com/",
    img:
      "./assets/2.jpg",
  },
  {
    id: 3,
    title: "Temp APP",
    link:"https://www.google.com",
    img:
      "./assets/3.jpg",
  },
 

];

export const contentPortfolio = [
  {
    id: 1,
    title: "Weather App",
    link:"https://weathercheck-h62r.onrender.com/",
    img:
      "./assets/1.jpg",
  },
  {
    id: 2,
    title: "Placement Management system",
    link:"https://placement-management-system45.onrender.com/",
    img:
      "./assets/2.jpg",
  },
  {
    id: 3,
    title: "Music",
    link:"https://45music.netlify.app",
    img:
      "./assets/3.jpg",
  
  },
 
];
